import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import useI18n from '@i18n/useI18n'

interface Props {
  score?: number
}

const ConformityCard = ({ score }: Props) => {
  const i18n = useI18n()

  return (
    <Card>
      <ConformityText>{i18n.t('components.conformity.rate')}</ConformityText>
      <Conformity>{score !== undefined ? `${Math.floor(score)}%` : i18n.t('errors.NC')}</Conformity>
    </Card>
  )
}

export default ConformityCard

const Card = styled(View)`
  background-color: ${(props) => props.theme.colors.alertButtonLight};
  border: 1px solid ${(props) => props.theme.colors.accent};
  border-radius: 12px;
  padding: ${(props) => (props.theme.breakpoint === 'phone' ? 8 : 14)}px
    ${(props) => (props.theme.breakpoint === 'phone' ? 8 : 16)}px;
  flex-direction: row;
  align-items: center;
`

const ConformityText = styled(Text)`
  ${(props) => (props.theme.breakpoint === 'phone' ? props.theme.fonts.Caption1 : props.theme.fonts.Subheadline)};
  color: ${(props) => props.theme.colors.accent};
  margin-right: ${(props) => (props.theme.breakpoint === 'phone' ? 12 : 24)}px;
  max-width: 75px;
`

const Conformity = styled(Text)`
  ${(props) => (props.theme.breakpoint === 'phone' ? props.theme.fonts.Subheadline : props.theme.fonts.Title2)};
  color: ${(props) => props.theme.colors.accent};
`
